import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Logo from "./logo.png";
import Logo1 from "./logo1.jpeg";
import UdayaSolutionLogo from "./UdayaSolutionLogo.png";
import Bluebutton from "../blueButton/Bluebutton";
import "./navb.css";
function Navb() {
  return (
    <Container>
      <div className="row justify-content-center">
        <Navbar
          collapseOnSelect
          expand="lg"
          className="col-lg-12 col-md-10 col-sm-10 col-xs-10 data-bs-theme-light w-100"
        >
          {/* <Container> */}
          <Navbar.Brand href="/">
            {/* <img className="logo" src={Logo} alt="Logo" /> */}
            <img className="logo" src={UdayaSolutionLogo} alt="Logo" />
            {/* <span className="brandname">Udaya Solutions</span> */}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto">
              <NavDropdown
                title="Services"
                className="NavLinkButton"
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item href="/Services/Strategic_Staffing_Solution">
                  Strategic Staffing Solution
                </NavDropdown.Item>
                <NavDropdown.Item href="/Services/Executive_Hiring">
                  Executive Hiring
                </NavDropdown.Item>
                <NavDropdown.Item href="/Services/Market_Research">
                  Market Research
                </NavDropdown.Item>
                <NavDropdown.Item href="/Services/Survey">Survey</NavDropdown.Item>
                <NavDropdown.Item href="/Services/Training_&_Development">Training & Development</NavDropdown.Item>
                <NavDropdown.Item href="/Services/HR_Business_Benchmarking">HR Business Benchmarking</NavDropdown.Item>
              </NavDropdown>

              {/* <Nav.Link className="NavLinkButton" href="/insights">
          Insights
          </Nav.Link> */}
              <Nav.Link className="NavLinkButton" href="/OurWorkingAreas">
                Our Working Areas
              </Nav.Link>
              <Nav.Link className="NavLinkButton" href="/about">
                About Us
              </Nav.Link>
              <Nav.Link className="NavLinkButton" href="/contact">
                Contact
              </Nav.Link>
              <Nav.Link className="NavLinkButton" href="/jobs">
                Career
              </Nav.Link>
              {/* <Bluebutton Text="Get in Touch" Link="contact" /> */}
              {/* <button className="bluebutton">Get in Touch</button> */}
              {/* <NavDropdown
            title="Products"
            className="NavLinkButton"
            id="basic-nav-dropdown"
          >
            <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.2">
              Another action
            </NavDropdown.Item>
            <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item href="#action/3.4">
              Separated link
            </NavDropdown.Item>
          </NavDropdown>
          <NavDropdown
            title="Recipies"
            className="NavLinkButton"
            id="basic-nav-dropdown"
          >
            <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.2">
              Another action
            </NavDropdown.Item>
            <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item href="#action/3.4">
              Separated link
            </NavDropdown.Item>
          </NavDropdown>
          <Nav.Link className="NavLinkButton" href="/social">
            Company
          </Nav.Link>
          <Nav.Link className="NavLinkButton" href="/product">
            Contact Us
          </Nav.Link> */}
            </Nav>
            <Nav className="ms-auto">
              <Bluebutton Text="Get An Appointment" Link="contact" />
            </Nav>
          </Navbar.Collapse>
          {/* </Container> */}
        </Navbar>
      </div>
    </Container>
  );
}

export default Navb;
